export const validateEmail = (e: string | undefined) => {
    if (!e) {
      return false;
    }
  
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return e.match(emailPattern) != null;
  };
  

export const validateURL = (u: string | undefined) => {
    if (!u) {
      return false;
    }

    const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(:\d+)?(\/[^\s]*)?$/;
    return u.match(urlRegex) != null;
}